import Route from '@ember/routing/route';

export default class EventNotFound extends Route {}
